<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Message</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            background:rgb(249, 253, 253);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            margin: 0;
        }
        .mpologo, .mnnlogo{
            width: 200px;
            height: auto;
            margin-bottom: 4rem;
        }
        .message{
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin: 0 3rem;
            text-align: center;
        }
        p{
            margin: 0;
            padding: 0;
            font-size: 24px;
            color: #333;
            max-width: 1000px;
        }

        
    </style>
</head>
<body>

<!-- LOGOS -->
<!-- MPO -->
<svg *ngIf="currentOrganization == 'dk'" class="mpologo" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 244.1 172.49">
  <defs><style>.cls-4{fill:#fff}</style></defs>
  <path d="M128.73 24.89a2 2 0 0 0-1.83-.24l-98.82 36a2 2 0 0 0-1.32 1.88V195a2 2 0 0 0 2.68 1.88l98.82-36a2 2 0 0 0 1.32-1.88V26.53a2 2 0 0 0-.85-1.64Z" transform="translate(-26.77 -24.52)" style="fill:#27bdbe"/>
  <path d="M200.41 24.89a2 2 0 0 0-1.83-.24l-98.82 36a2 2 0 0 0-1.32 1.88V195a2 2 0 0 0 2.68 1.88l98.81-36a2 2 0 0 0 1.32-1.88V26.53a2 2 0 0 0-.84-1.64Z" transform="translate(-26.77 -24.52)" style="fill:#00a99d"/>
  <path d="M270 24.89a2 2 0 0 0-1.83-.24l-98.82 36a2 2 0 0 0-1.32 1.88V195a2 2 0 0 0 2.68 1.88l98.82-36a2 2 0 0 0 1.32-1.88V26.53a2 2 0 0 0-.85-1.64Z" transform="translate(-26.77 -24.52)" style="fill:#008083"/>
  <path class="cls-4" d="M56.14 88.67c0-3 1.63-3.64 3.64-3.64H70c2.11 0 3.26 1.34 4 3.35l17.43 43.48 17-43.38c.77-2.11 2.2-3.45 4.31-3.45h9.86c2 0 3.64.67 3.64 3.64v57.84c0 3-1.63 3.64-3.64 3.64h-5.17c-2 0-3.64-.67-3.64-3.64v-42.42h-.19L96 146.9c-.77 1.92-1.44 3.26-3.54 3.26h-2.8c-2.11 0-2.87-1.34-3.64-3.26L68.78 105h-.19v41.56c0 3-1.63 3.64-3.64 3.64h-5.17c-2 0-3.64-.67-3.64-3.64V88.67ZM135.82 88.67c0-3 1.63-3.64 3.64-3.64h18.77c10.25 0 22.6 4.69 22.6 20.69 0 15-11.2 20.59-21.55 20.59h-10.44v20.21c0 3-1.63 3.64-3.64 3.64h-5.75c-2 0-3.64-.67-3.64-3.64V88.67Zm21.45 26.62c8.71 0 10.63-5.36 10.63-9.58 0-4.41-3.06-9.58-10.53-9.58h-8.52v19.17h8.43ZM217.6 83.79c21.45 0 33.52 16.38 33.52 33.9 0 17.33-12.07 33.71-33.52 33.71s-33.52-16.4-33.52-33.71c0-17.53 12.16-33.9 33.52-33.9Zm0 56c12.83 0 19.54-10.53 19.54-22.12 0-11.78-6.7-22.22-19.54-22.22s-19.44 10.44-19.44 22.22c0 11.61 6.7 22.14 19.44 22.14Z" transform="translate(-26.77 -24.52)"/>
</svg>

<!-- Display Music Nest logo for Norway (no) -->
<svg *ngIf="currentOrganization == 'no'" class="mnnlogo" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 567 240" xmlns="http://www.w3.org/2000/svg">
  <g fill-rule="nonzero">
    <path d="M356.39 239.97c-6.21 0-11.97-3.68-14.48-9.57L283.35 93.02v89.54c0 8.7-7.05 15.75-15.75 15.75s-15.75-7.05-15.75-15.75V15.93c0-7.48 5.26-13.93 12.6-15.43 7.33-1.5 14.7 2.37 17.64 9.25l58.57 137.38V57.58c0-8.7 7.05-15.75 15.75-15.75s15.75 7.05 15.75 15.75v166.64c0 7.48-5.26 13.93-12.6 15.43-1.06.22-2.12.32-3.17.32zM407.46 239.97c-8.7 0-15.75-7.05-15.75-15.75V57.58c0-7.49 5.27-13.94 12.6-15.43s14.71 2.38 17.64 9.27l40.78 95.95 32.4-56.02c2.81-4.87 8.01-7.86 13.63-7.86h41.58c8.7 0 15.75 7.05 15.75 15.75s-7.05 15.75-15.75 15.75h-32.5l-43.64 75.45c-2.99 5.17-8.65 8.21-14.6 7.83-5.96-.37-11.2-4.07-13.53-9.56l-22.88-53.83v89.33c.02 8.71-7.03 15.76-15.73 15.76zM216.54 198.31c-8.7 0-15.75-7.05-15.75-15.75V93.18l-40.54 95.54c-2.47 5.82-8.18 9.6-14.5 9.6s-12.03-3.78-14.5-9.6L92.72 97.88l-20.9 49.18c-2.47 5.81-8.18 9.59-14.49 9.59H15.75C7.05 156.65 0 149.6 0 140.9s7.05-15.75 15.75-15.75h31.17l31.33-73.73c2.47-5.81 8.18-9.59 14.49-9.59 6.32 0 12.02 3.78 14.49 9.6l38.53 90.81L202.04 9.6c2.92-6.89 10.3-10.77 17.64-9.28s12.61 7.94 12.61 15.43v166.81c0 8.7-7.05 15.75-15.75 15.75z"/>
  </g>
</svg>


<!-- STANDARD SHORT TERM DOWNTIME MESSAGE -->
 <!-- <div class="message">
    <p>Our platform is <b>temporarily</b> unavailable while we perform <b>essential</b> updates.</p>
    <p>We <b>appreciate</b> your understanding and invite you to <b>check back again</b> soon.</p>
</div> -->


<!-- MESSAGE FOR LABEL AGENTS -->
<div class="message">
    <p><b>Temporary Access Restriction for Label Agents</b></p>
    <p>To support a major platform upgrade, access for Label Agents is temporarily disabled while we complete essential updates and refactor key logic.</p>
    <p>There are no expected deadlines before early September, so this change should have no practical impact. We’ll notify you as soon as access is restored — currently anticipated in late August.</p>
    <p>Once you're back in, you can look forward to improved performance, including bulk searches and the ability to assign up to 5,000 items at once, along with support for claims on subaccounts.</p>
    <p>Once access is restored, we’ll be here to support you and ensure the temporary downtime causes as little disruption as possible.</p>
    <p>Thank you for your understanding and patience!</p>
</div>
   
</body>
</html>